<form [formGroup]="projectDataForm" class="d-flex flex-column md:gap-x-4 gap-y-4">
    <div class="grid grid-cols-12 md:gap-x-4 gap-y-4">
        <kendo-formfield class="col-span-12 md:col-span-9">
            <kendo-label class="form-label" [for]="title" text="{{'project-data.projectTitle' | translate}} *" [infotooltip]="'projektdaten.titel'"></kendo-label>
            <kendo-textbox id="title" #title formControlName="title" showSuccessIcon="initial" showErrorIcon="initial" [appinfotext]="'projektdaten.titel'" preventEmptyFormatter 
            [maxlength]=200
            (paste)="this.textBoxService.onPaste($event, this.projectDataForm.Title, 200)"
            ></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield class="col-span-12 md:col-span-3">
            <kendo-label class="form-label" [for]="kurzTitel" text="{{'project-data.shortTitle' | translate}}" [infotooltip]="'projektdaten.kurztitel'"></kendo-label>
            <kendo-textbox id="kurzTitel" #kurzTitel formControlName="kurzTitel" showSuccessIcon="initial" showErrorIcon="initial" [appinfotext]="'projektdaten.kurztitel'" preventEmptyFormatter 
            [maxlength]=100
            (paste)="this.textBoxService.onPaste($event, this.projectDataForm.KurzTitel, 100)"
            ></kendo-textbox>
        </kendo-formfield>
    
        <div class="col-span-12 md:col-span-9 grid grid-cols-12 md:gap-x-4 gap-y-4">
            <kendo-formfield class="col-span-12 md:col-span-6">
                <kendo-label class="form-label" [for]="projektStart" text="{{'project-data.plannedProjectStart' | translate }} *" [infotooltip]="'projektdaten.projektstart'"></kendo-label>
                <kendo-datepicker
                    #projektStart
                    (valueChange)="onProjektStartChange($event)"
                    formControlName="projektStart"
                    [appinfotext]="'projektdaten.projektstart'"
                    [format]="dateFormat"
                    [incompleteDateValidation]="true"></kendo-datepicker>
            </kendo-formfield>
            <kendo-formfield class="col-span-12 md:col-span-6" [ngClass]="{ 'opacity-50': !projektStart.value }">
                <kendo-label class="form-label" [for]="projektEnd" text="{{'project-data.plannedProjectEnd' |translate}} *" [infotooltip]="'projektdaten.projektende'"></kendo-label>
                <kendo-datepicker
                    #projektEnd
                    formControlName="projektEnd"
                    [min]="projektStart.value ?? noMinDate()"
                    [readonly]="!projektStart.value"
                    [disabled]="!projektStart.value"
                    [appinfotext]="'projektdaten.projektende'"
                    [incompleteDateValidation]="true"
                    [format]="dateFormat"></kendo-datepicker>
                    <kendo-formerror *ngIf="endBeforeStartErrorMessage">{{ endBeforeStartErrorMessage }}</kendo-formerror>
            </kendo-formfield>
        </div>
        
    </div>
    
    <kendo-formfield class="mt-8">
        <kendo-label class="form-label" for="projektbeschreibung" text="{{'project-data.projectDescription'|translate}} *" [infotooltip]="'projektdaten.projektbeschreibung'"></kendo-label>
        <ckeditor id="projektbeschreibung" formControlName="projektbeschreibung" (ready)="initCKEditor($event, 'word-count-projektbeschreibung')" [appinfotext]="'projektdaten.projektbeschreibung'"></ckeditor>
        <div id="word-count-projektbeschreibung"></div>
    </kendo-formfield>
    
    <kendo-formfield>
        <kendo-label class="form-label" for="projektbeteiligte" text="{{'project-data.projectParticipants' | translate }} *" [infotooltip]="'projektdaten.projektbeteiligte'"></kendo-label>
        <ckeditor id="projektbeteiligte" formControlName="projektbeteiligte" (ready)="initCKEditor($event, 'word-count-projektbeteiligte')" [appinfotext]="'projektdaten.projektbeteiligte'"></ckeditor>            
        <div id="word-count-projektbeteiligte"></div>
    </kendo-formfield>
</form>
